import { Action } from "../models/notification";
import { FETCH_NOTIFICATION, SET_NOTIFICATION } from "../constants/notification";
import { combineReducers } from "redux";
import { getErrorReducer, getIndexesReducer, getStatusReducer } from "../utils/reducer-generators";
import { INotificationItem, INotificationList } from "../types";

export const initialNotification: INotificationItem = {
  id: 0,
  notification: {
    id: 0,
    title: "",
    message: "",
    created: "",
  },
  seen: false,
  created: "",
};

const initialState: INotificationList = [
  {
    unreadNotifsCount: 0,
  },
  initialNotification,
];

const data = (state: INotificationList = initialState, action: Action): INotificationList => {
  switch (action.type) {
    case SET_NOTIFICATION: {
      const notifications = action.payload.notification;
      const filteredNotifications = notifications.slice(1);
      const sortedNotifications = filteredNotifications.sort((a, b) => {
        if ("seen" in a && "seen" in b) {
          return a.seen === b.seen ? 0 : a.seen ? 1 : -1;
        }
        return 0;
      });

      return [notifications[0], ...sortedNotifications] as INotificationList;
    }
    default:
      return state;
  }
};

export default combineReducers({
  status: getStatusReducer([FETCH_NOTIFICATION]),
  error: getErrorReducer([FETCH_NOTIFICATION]),
  indexes: getIndexesReducer(FETCH_NOTIFICATION),
  data,
});
